import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

import { SiteSeoInfoQueryQuery } from "../generated/graphql-types"

type SeoProps = {
  location: any,
  title?: string,
  description?: string,
  lang?: "jp" | "en",
  image?: any,
  meta?: any,
};

export default ({ location, title, description, lang, image, meta }: SeoProps) => {
  const { site, allFile } = useStaticQuery<SiteSeoInfoQueryQuery>(graphql`
    query SiteSeoInfoQuery {
      site {
        siteMetadata {
          title
          description
          iconName
          siteUrl
        }
      }
      allFile(filter: { ext: { regex: "/(png|jpg)/" } }) {
        nodes {
          relativePath
          publicURL
        }
      }
    }
  `);

  const barTitle = site.siteMetadata?.title == null
    ? (title == null ? "Yondemy" : title)
    : (title == null ? site.siteMetadata?.title : (`${title} | ${site.siteMetadata?.title}`))
  title = title || "Top";
  lang = lang || "jp";
  meta = meta || [];
  description = description || site.siteMetadata.description

  let imagePath = null;
  if(allFile?.nodes && site?.siteMetadata?.iconName) {
    for(let i = 0; i < allFile.nodes.length; i++) {
      if(allFile.nodes[i].relativePath === site?.siteMetadata?.iconName) {
        imagePath = allFile.nodes[i].publicURL;
        break;
      }
    }
  }
  let containImage = false;
  if(allFile?.nodes && image) {
    for(let i = 0; i < allFile.nodes.length; i++) {
      if(allFile.nodes[i].relativePath === image) {
        imagePath = allFile.nodes[i].publicURL;
        containImage = true;
        break;
      }
    }
  }

  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={barTitle}
      meta={[
        {
          name: `description`,
          content: description,
        },
        {
          property: `og:url`,
          content: (site.siteMetadata?.siteUrl || "") + location.pathname,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: description,
        },
        {
          property: `og:site_name`,
          content: site.siteMetadata?.title || `Yondemy`,
        },
        (imagePath ? {
          property: `og:image`,
          content: (site.siteMetadata?.siteUrl || "") + imagePath,
        } : null),
        {
          property: `twitter:card`,
          content: containImage ? `summary_large_image` : `summary`,
        },
        {
          property: `twitter:title`,
          content: barTitle,
        },
      ].filter(x => x).concat(meta)}
    />
  )
}
